export default __webpack_public_path__ + "72b710f8756a14a4571712f825d3be16.svg";